// extracted by mini-css-extract-plugin
export default {"container":"TypeNumber_container__vqbHX"};